export class ApiError extends Error {
  constructor({
    status = 0,
    message = 'Request failed',
    errors = {},
    data = {},
    code = null,
    payload = null,
    retryAfterSeconds = null,
    isNetworkError = false,
    isMalformed = false,
  } = {}) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.errors = errors && typeof errors === 'object' && !Array.isArray(errors) ? errors : {};
    this.data = data && typeof data === 'object' && !Array.isArray(data) ? data : {};
    this.code = code;
    this.payload = payload;
    this.retryAfterSeconds = retryAfterSeconds == null ? null : Number(retryAfterSeconds);
    this.isNetworkError = isNetworkError;
    this.isMalformed = isMalformed;
  }

  get fieldErrors() {
    return this.errors;
  }

  get remainingAttempts() {
    if (this.data?.remaining_attempts == null) {
      return null;
    }
    const value = Number(this.data.remaining_attempts);
    return Number.isFinite(value) ? value : null;
  }

  get nextStep() {
    return this.data?.next_step || null;
  }

  isUnauthorized() {
    return this.status === 401;
  }

  isForbidden() {
    return this.status === 403;
  }

  isNotFound() {
    return this.status === 404;
  }

  isConflict() {
    return this.status === 409;
  }

  isValidation() {
    return this.status === 422;
  }

  isThrottled() {
    return this.status === 429;
  }

  shouldNotRetry() {
    return this.status === 409 || this.status === 422 || this.status === 429;
  }
}

export function isApiError(error) {
  return error instanceof ApiError;
}
